<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>运营管理</a-breadcrumb-item>
    <a-breadcrumb-item>快手结算</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 头部功能条 -->
  <div class="head-tool-view">
    <div style="position: relative;">
      <!-- 项目 -->
      <span class="tool-title">项目：</span>
      <a-select
        style="width: 200px;"
        v-model:value="cprojectID"
        placeholder="请选择"
      >
        <a-select-option
          v-for="item in projectList"
          :key="item.id"
          :value="item.id"
        >
          {{ item.name }}
        </a-select-option>
      </a-select>
      <!-- 日期 -->
      <span class="tool-title">支付日期：</span>
      <a-range-picker
        v-model:value="cdateRange"
        :format="dateFormat"
        :disabled-date="disabledDate"
      />
      <!-- 操作 -->
      <a-button type="primary" style="margin-left: 16px;" @click="touchSettlement">发起结算</a-button>
      <!-- 加载组件 -->
      <Loading :loading="cisLoading"></Loading>
    </div>
    <!-- 分割线 -->
    <div class="head-tool-space"></div>
  </div>
  <!-- 功能条 -->
  <div class="tool-view">
    <!-- 项目 -->
    <span class="tool-title">项目：</span>
    <a-select
      style="width: 200px;"
      v-model:value="projectID"
      placeholder="请选择"
    >
      <a-select-option
        v-for="item in projectList"
        :key="item.id"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
    <!-- 操作 -->
    <a-button type="primary" style="margin-left: 16px;" @click="handleSearch">查询</a-button>
    <a-button style="margin-left: 16px;" @click="handleReset">重置</a-button>
    <div style="flex: 1;"></div>
  </div>
  <!-- 列表 -->
  <a-table
    class="table-view"
    :data-source="dataSource"
    :columns="columns"
    :row-key="record => record.id"
    :pagination="pagination"
    :loading="isLoading"
    @change="handleTableChange"
  >
    <!-- 自定义行内容 -->
    <template #bodyCell="{ column, record }">
      <!-- 项目 -->
      <template v-if="column.key === 'project_name'">
        {{ record.project.name }}
      </template>
      <!-- 订单日期 -->
      <template v-if="column.key === 'order_time'">
        {{ `${record.start_time} 至 ${record.end_time}` }}
      </template>
      <!-- 金额 -->
      <template v-if="column.key === 'order_amount' || column.key === 'settlement_amount'">
        {{ $pub.KEEP_NUMBER_DECIMAL((record[column.key] || 0) / 100, 2, false, true) }}
      </template>
      <!-- 操作 -->
      <template v-if="column.key === 'operation'">
        <a class="operation-item" @click="touchInfo(record)">查看</a>
      </template>
    </template>
  </a-table>
  <!-- 发起退款 -->
  <SettlementDrawer ref="RefSettlementDrawer" @success="getList"></SettlementDrawer>
</template>

<script setup>
import { onBeforeMount, ref, reactive, createVNode } from 'vue'
import { message, Modal } from 'ant-design-vue'
import Pub from '@/utils/public'
import dayjs from 'dayjs'
import { PayChannels, RefundStatus, RefundPayChannels } from '@/utils/constant'
import { settlementDetail, settlementList, settlementProjectList } from '@/api/copyright'
import Loading from '@/components/Loading'
import SettlementDrawer from './components-kssettlement/SettlementDrawer'

// 发起结算
let RefSettlementDrawer = ref(null)
// 加载
let isLoading = ref(false)
// 日期format
const dateFormat = 'YYYY-MM-DD'
// 头部 - 日期范围
let cdateRange = ref([])
// 头部 - 加载
let cisLoading = ref(false)
// 头部 - 项目
let cprojectID = ref(undefined)
// 项目
let projectID = ref(undefined)
// 项目列表
let projectList = ref([])
// 数据源
let dataSource = ref([])
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})
// 列数据源（付费转化率、权重本期不做）
let columns = ref([
  {
    title: '结算时间',
    dataIndex: 'settlement_time',
    key: 'settlement_time'
  },
  {
    title: '项目',
    dataIndex: 'project_name',
    key: 'project_name'
  },
  {
    title: '订单日期',
    dataIndex: 'order_time',
    key: 'order_time'
  },
  {
    title: '订单总数',
    dataIndex: 'order_count',
    key: 'order_count'
  },
  {
    title: '订单总金额(元)',
    dataIndex: 'order_amount',
    key: 'order_amount'
  },
  {
    title: '结算总金额(元)',
    dataIndex: 'settlement_amount',
    key: 'settlement_amount'
  }
])

// 钩子函数
onBeforeMount (() => {
  // 获取注册用户列表
  getList()
  // 项目列表
  getProjectList()
})

// 限制可选时间范围
function disabledDate (current) {
  return current && current > dayjs().subtract(4, 'day')
}

// 新建回传
function touchSettlement () {
  if (!cprojectID.value) {
    message.error('项目不能为空')
    return
  }
  if (!cdateRange.value) {
    message.error('支付日期不能为空')
    return
  }
  RefSettlementDrawer.value.showDrawer({})
  cisLoading.value = true
  const params = {
    project_id: cprojectID.value,
    start_time: cdateRange.value[0].format(dateFormat),
    end_time: cdateRange.value[1].format(dateFormat)
  }
  settlementDetail(params).then(res => {
    cisLoading.value = false
    const { code, data } = res
    if (code === 0) {
      RefSettlementDrawer.value.showDrawer(data)
    } else {
      Modal.error({
        title: '创建失败',
        content: res.message
      })
    }
  }).catch(() => {
    cisLoading.value = false
    message.error('读取失败')
  })
}

// 项目列表
function getProjectList () {
  settlementProjectList().then(res => {
    const { code, data } = res
    if (code === 0) {
      projectList.value = data
    }
  })
}

// 获取列表
function getList () {
  isLoading.value = true
  const params = {
    project_id: projectID.value,
    page: pagination.current,
    page_size: pagination.pageSize
  }
  settlementList(params).then(res => {
    isLoading.value = false
    const { code, data, msg } = res
    if (code === 0) {
      dataSource.value = data.data
      pagination.total = data.total
    } else {
      message.error(res.message || msg)
    }
  })
}

// 分页处理
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getList()
}

// 查询
function handleSearch () {
  pagination.current = 1
  // 获取列表
  getList()
}

// 重置
function handleReset () {
  // 筛选项重置
  projectID.value = undefined
  // 分页重置
  pagination.current = 1
  getList()
}

</script>

<style scoped>
.head-tool-view {
  padding-top: 30px;
}
.head-tool-space {
  margin-top: 30px;
  height: 30px;
  background-color: #F0F2F5;
  margin-left: -24px;
  margin-right: -24px;
}
.tool-view {
  display: flex;
  align-items: center;
  margin-top: 30px;
}
.table-view {
  margin-top: 30px;
}
.tool-title:not(:first-child) {
  margin-left: 16px;
}

</style>